var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknownTypeOp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.174 2H5.82627C4.82197 2 4.0002 2.80899 4.0002 3.79767V5.78026H28V3.79767C28 2.80899 27.1783 2 26.174 2ZM4 6.98692V16.2023C4 17.191 4.82177 18 5.82607 18H26.1738C27.1781 18 27.9999 17.191 27.9999 16.2023V6.98692H4ZM24.5327 12.386C24.8709 12.386 25.1454 12.6561 25.1454 12.9891C25.1454 13.322 24.8709 13.5922 24.5327 13.5922H22.4703C22.132 13.5922 21.8576 13.322 21.8576 12.9891C21.8576 12.6561 22.1321 12.386 22.4703 12.386H24.5327ZM9.53007 12.386C9.86831 12.386 10.1427 12.6561 10.1427 12.9891C10.1427 13.322 9.86829 13.5922 9.53007 13.5922H7.46765C7.12941 13.5922 6.85499 13.322 6.85499 12.9891C6.85499 12.6561 7.12943 12.386 7.46765 12.386H9.53007ZM14.5308 12.386C14.8691 12.386 15.1435 12.6561 15.1435 12.9891C15.1435 13.322 14.8691 13.5922 14.5308 13.5922H12.4684C12.1302 13.5922 11.8558 13.322 11.8558 12.9891C11.8558 12.6561 12.1302 12.386 12.4684 12.386H14.5308ZM19.5318 12.386C19.8701 12.386 20.1445 12.6561 20.1445 12.9891C20.1445 13.322 19.87 13.5922 19.5318 13.5922H17.4694C17.1312 13.5922 16.8567 13.322 16.8567 12.9891C16.8567 12.6561 17.1312 12.386 17.4694 12.386H19.5318Z",
    fill: "#DDDDDD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 10,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1428 18.8572C25.5116 18.8572 25 18.3454 25 17.7142V13.1428C25 12.5116 25.5116 12 26.1428 12H30.7142C31.3454 12 31.8572 12.5116 31.8572 13.1428V17.7142C31.8572 18.3454 31.3454 18.8572 30.7142 18.8572H26.1428ZM27.2856 14.2856V16.5714H29.5714V14.2856H27.2856Z",
    fill: "#DDDDDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 26.8574C25 27.4886 25.5116 28.0002 26.1428 28.0002H30.7142C31.3454 28.0002 31.8572 27.4886 31.8572 26.8574V22.2859C31.8572 21.6547 31.3454 21.1429 30.7142 21.1429H26.1428C25.5116 21.1429 25 21.6547 25 22.2859V26.8574ZM27.2856 25.7146V23.4288H29.5714V25.7146H27.2856Z",
    fill: "#DDDDDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2862 18.8572C34.655 18.8572 34.1432 18.3454 34.1432 17.7142V13.1428C34.1432 12.5116 34.655 12 35.2862 12H39.8576C40.4888 12 41.0004 12.5116 41.0004 13.1428V17.7142C41.0004 18.3454 40.4888 18.8572 39.8576 18.8572H35.2862ZM36.429 14.2856V16.5714H38.7148V14.2856H36.429Z",
    fill: "#DDDDDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1432 21.1426H36.429V23.4284H34.1432V21.1426Z",
    fill: "#DDDDDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7148 23.4287H36.429V25.7145H34.1432V28.0001H36.429V25.7145H38.7148V23.4287Z",
    fill: "#DDDDDD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7148 23.4288V21.1429H41.0005V23.4288H38.7148Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownTypeOp);
export default __webpack_public_path__ + "static/media/unknown-type-op.9a75897b9540bb2ecc4104688fbb8f03.svg";
export { ForwardRef as ReactComponent };